"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var defaultDateSpecifier = '%-m-%-d-%Y %-I:%M %p';
var _default = exports["default"] = defaultDateSpecifier;
//# sourceMappingURL=defaultDateSpecifier.js.map